/**
 * Deprecated — redirects to /admin/website-sync.
 */

import { Navigate } from 'react-router-dom'

export function WebsiteSyncSettingsPage() {
  return <Navigate to="/admin/website-sync" replace />
}
